import React, { Component } from 'react';
import ParentComponent, {
  TParentComponentProps,
} from '@views/components/common/ParentComponent';
import classNames from 'classnames';
import ShopLayoutSidebar from './ShopLayoutSidebar';
import ShopLayoutContent from './ShopLayoutContent';

export type TShopLayoutProps = TParentComponentProps & {
  sidebarLeft?: boolean;
};
export class ShopLayout extends Component<TShopLayoutProps> {
  static defaultProps = {
    defaultClassName: 'shop-layout',
  };
  static Sidebar = ShopLayoutSidebar;
  static Content = ShopLayoutContent;

  render() {
    const { className, sidebarLeft, ...otherProps } = this.props;
    const cx = classNames({
      'shop-layout--sidebar-left': sidebarLeft,
      [className]: !!className,
    });

    return <ParentComponent className={cx} {...otherProps} />;
  }
}

export default ShopLayout;
